import { Checkbox, FormControlLabel } from '@mui/material';
import { Control, Controller, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CvAuthorisationDownload from '@/components/Pbl/CvAuthorisationDownload';
import { PblCvAuthorisation } from '@/types/pbl';
import { LawyerCvFormValues } from './formValues';

export const authorisationConfirmations = [
  ['firm_authorisation_confirmed', 'confirmAuthorisation'],
  ['firm_authorisation_letter_attached', 'confirmLetterAttached'],
  ['law_firm_change_notify_agreed', 'agreeNotifyChange'],
] as const;

export default function AuthorisationFields({
  control,
  disabled,
  profileId,
  revisionId,
  saved,
}: {
  control: Control<LawyerCvFormValues>;
  disabled: boolean;
  profileId?: number;
  revisionId?: number;
  saved?: PblCvAuthorisation;
}) {
  // @ts-ignore -- legacy translation catalog exceeds recursive key inference.
  const { t } = useTranslation();
  const tr = (key: string) => t(key as any) as string;
  const fileId = useWatch({ control, name: 'firm_authorisation_file_id' });
  return (
    <>
      <p>{tr('pbl.lawyerRegistration.authorisation.intro')}</p>
      <p>
        <a
          href="https://www.ebram.org/download/Annex_1_Firm_authorisation_template.pdf"
          target="_blank"
          rel="noopener noreferrer"
        >
          {tr('pbl.lawyerRegistration.authorisation.downloadTemplate')}
        </a>
      </p>
      {profileId && fileId && fileId === saved?.firm_authorisation_file_id ? (
        <CvAuthorisationDownload profileId={profileId} revisionId={revisionId} fileName={saved.file_name} />
      ) : null}
      {authorisationConfirmations.map(([name, label]) => (
        <Controller
          key={name}
          name={name}
          control={control}
          render={({ field }) => (
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!field.value}
                  disabled={disabled}
                  onChange={(event) => field.onChange(event.target.checked)}
                />
              }
              label={tr(`pbl.lawyerRegistration.authorisation.${label}`)}
            />
          )}
        />
      ))}
    </>
  );
}
